import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { i18nDateToString } from 'modules/core/lib/dates'

import { ScheduleRecordValuesType } from '../../../../types'
import { cellText } from '../../../../utils'

interface ISubRowCellHoverContentProps {
  record: ScheduleRecordValuesType
}

const SubRowCellHoverContent = ({ record }: ISubRowCellHoverContentProps) => {
  const startDate = moment(record.startDate)
  const endDate = moment(record.endDate)
  const nDays = endDate.diff(startDate, 'days') + 1

  return (
    <Box gap="s12">
      <Box
        padding="s6"
        border={{ all: { color: 'grey400', width: 's1', style: 'solid' } }}
        borderRadius={{ all: 'abs008' }}
        gap="s4"
        flexDirection="row"
        alignItems="center"
      >
        <Icon.Medium icon="calendar" color="grey700" />
        <Text.Normal size="200" color="grey1000">{`${i18nDateToString(
          moment(startDate),
          'ui'
        )} - ${i18nDateToString(moment(endDate), 'ui')}`}</Text.Normal>
      </Box>
      <Box
        padding="s6"
        border={{ all: { color: 'grey400', width: 's1', style: 'solid' } }}
        borderRadius={{ all: 'abs008' }}
        gap="s4"
        flexDirection="row"
        alignItems="center"
      >
        <Icon.Medium icon="clock" color="grey700" />
        <Text.Normal size="200" color="grey1000">{`${cellText(record.dailyMinutes)} -> ${cellText(
          record.dailyMinutes * nDays,
          null,
          'total'
        )}`}</Text.Normal>
      </Box>
    </Box>
  )
}

export default SubRowCellHoverContent
